import { PayloadAction, SerializedError } from "@reduxjs/toolkit";

export function handleSliceRejectionDefault(error: PayloadAction<unknown, string, {
    arg: any;
    requestId: string;
    requestStatus: "rejected";
    aborted: boolean;
    condition: boolean;
  } & ({
    rejectedWithValue: true;
  } | ({
    rejectedWithValue: false;
  } & {})), SerializedError>) {
  console.error(`${error.type} - ${error.payload}`);
}